import { render, staticRenderFns } from "./ReportTemplatePopover.vue?vue&type=template&id=4a889ce1&scoped=true&"
import script from "./ReportTemplatePopover.vue?vue&type=script&lang=js&"
export * from "./ReportTemplatePopover.vue?vue&type=script&lang=js&"
import style0 from "./ReportTemplatePopover.vue?vue&type=style&index=0&id=4a889ce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a889ce1",
  null
  
)

export default component.exports